// extracted by mini-css-extract-plugin
export default {"container":"chat-page_container__fh8N5","plus-container":"chat-page_plus-container__mzsTp","plus":"chat-page_plus__233Kq"};